enum ArcgisIntegrationType {
  zone = 'zone',
  area = 'area',
  location = 'location',
}

export default ArcgisIntegrationType
